(() => {
  if (window.__productCardTpgAtcBound) return;

  const getSectionsToRender = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    const drawerSectionId = cartDrawer?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    let sections = 'cart-icon-bubble';

    if (drawerSectionId) {
      sections += `,${drawerSectionId}`;
    }

    return { sections, cartDrawer };
  };

  document.addEventListener('click', async (event) => {
    const addButton = event.target.closest('.product_card_tpg .prod-add');
    if (!addButton || !document.body.contains(addButton)) return;

    event.preventDefault();
    event.stopPropagation();

    if (addButton.disabled || addButton.getAttribute('aria-disabled') === 'true') return;

    const variantId = addButton.dataset.variantId;
    if (!variantId || !window.theme?.routes?.cartAdd) return;

    const { sections, cartDrawer } = getSectionsToRender();
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sections);

    addButton.setAttribute('aria-disabled', 'true');
    addButton.classList.add('is-loading');

    try {
      const response = await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || response.statusText);
      }

      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble && data.sections?.['cart-icon-bubble']) {
        cartIconBubble.innerHTML = data.sections['cart-icon-bubble'];
      }

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data, window.theme?.settings?.afterAtc === 'drawer');
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      }
    } catch (error) {
      console.error(error);
    } finally {
      addButton.removeAttribute('aria-disabled');
      addButton.classList.remove('is-loading');
    }
  });

  window.__productCardTpgAtcBound = true;
})();
